import { driver } from 'driver.js';
import 'driver.js/dist/driver.css';
import { ElMessage } from 'element-plus';
import stage1Tw from '@/assets/img/stage1-zhtw.png';
import stage1En from '@/assets/img/stage1-en.png';
import stage1Cn from '@/assets/img/stage1-cn.png';
import stage2Tw from '@/assets/img/stage2-zhtw.png';
import stage2En from '@/assets/img/stage2-en.png';
import stage2Cn from '@/assets/img/stage2-cn.png';
import stage3Tw from '@/assets/img/stage3-zhtw.png';
import stage3En from '@/assets/img/stage3-en.png';
import stage3Cn from '@/assets/img/stage3-cn.png';
import stage4Tw from '@/assets/img/stage4-zhtw.png';
import stage4En from '@/assets/img/stage4-en.png';
import stage4Cn from '@/assets/img/stage4-cn.png';
import stage5Tw from '@/assets/img/stage5-zhtw.png';
import stage5En from '@/assets/img/stage5-en.png';
import stage5Cn from '@/assets/img/stage5-cn.png';
import setFlowTw from '@/assets/img/setFlow-zhtw.png';
import setFlowEn from '@/assets/img/setFlow-en.png';
import setFlowCn from '@/assets/img/setFlow-cn.png';
import flowChartTw from '@/assets/img/OCAP_FlowEx-zhtw.png';
import flowChartEn from '@/assets/img/OCAP_FlowEx-en.png';
import flowChartCn from '@/assets/img/OCAP_FlowEx-cn.png';

/**
 * 呼叫 OCAP關卡設定
 * @param {*} i18n
 * @param {*} store
 */
export function callHelpStageSetting(i18n, store) {
  const driverObj = driver({
    showProgress: true,
    steps: [
      {
        element: '.filterBtn',
        popover: {
          title: i18n.$t('OCAP').filterStageSetting,
          description: i18n.$t('OCAP').filterStageSettingExplain,
        },
      },

      {
        element: '.createBtn',
        popover: {
          title: i18n.$t('OCAP').createStageSetting,
          description: i18n.$t('OCAP').createStageSettingExplain,
          onNextClick: () => {
            if (store.state.ocap.stageSettingFormVisible) {
              driverObj.moveNext();
            } else {
              driverObj.destroy();

              ElMessage({
                showClose: true,
                message: i18n.$t('DriverTourHelp').ClickAddButtonFirst,
                type: 'error',
                duration: 3000,
              });

              setTimeout(() => {
                driverObj.drive();
                driverObj.moveTo(1);
              }, 3000);
            }
          },
        },
      },

      {
        element: '.nameInput',
        popover: {
          title: i18n.$t('OCAP').stageSetting,
          description: i18n.$t('OCAP').nameExplain,
        },
      },

      {
        element: '.addStage',
        popover: {
          title: i18n.$t('OCAP').addStage,
          description: i18n.$t('OCAP').addStageExplain,
        },
      },

      {
        element: '.insertStage',
        popover: {
          title: i18n.$t('OCAP').insertStage,
          description: i18n.$t('OCAP').insertStageExplain,
        },
      },

      {
        element: '.el-table_2_column_4.is-leaf.el-table__cell',
        popover: {
          title: i18n.$t('OCAP').stageSequenceExplain,
          description: i18n.$t('OCAP').stageMaxExplain,
        },
      },

      {
        element: '#isSign',
        popover: {
          title: i18n.$t('OCAP').isSign,
          description: `
          <p>${i18n.$t('OCAP').isSignExplain}</p>
          <p>${i18n.$t('OCAP').functionExplain}</p>
          <p>${i18n.$t('OCAP').checkExplain}</p>`,
        },
      },

      {
        element: '#isAllSign',
        popover: {
          title: i18n.$t('OCAP').isAllSign,
          description: i18n.$t('OCAP').isAllSignExplain,
        },
      },

      {
        element: '#eMailNotice',
        popover: {
          title: i18n.$t('OCAP').eMailNotice,
          description: i18n.$t('OCAP').eMailNoticeExplain,
        },
      },

      {
        element: '#signerSetting',
        popover: {
          title: i18n.$t('OCAP').signerSetting,
          description: i18n.$t('OCAP').signerSettingExplain,
        },
      },

      {
        element: '#deleteStage',
        popover: {
          title: i18n.$t('OCAP').deleteStage,
          description: i18n.$t('OCAP').deleteStageExplain,
        },
      },

      {
        element: '.btn-confirm',
        popover: {
          title: i18n.$t('OCAP').confirmStage,
          description: i18n.$t('OCAP').confirmStageExplain,
        },
      },

      {
        popover: {
          title: i18n.$t('OCAP').stageSetting,
          description: `
          <p>${i18n.$t('OCAP').stageModifySignerExplain}</p>
          <p>${i18n.$t('OCAP').stageAlreadyUseExplain}</p>`,
        },
      },
    ],
    prevBtnText: i18n.$t('DriverTourHelp').previous,
    nextBtnText: i18n.$t('DriverTourHelp').next,
    doneBtnText: i18n.$t('DriverTourHelp').done,
  });

  driverObj.drive();
}

/**
 * 呼叫 編輯與刪除 OCAP關卡設定
 * @param {*} i18n
 * @param {*} store
 */
export function callHelpEditDeleteStageSetting(i18n, store) {
  const tempList = store.state.ocap.stageSettingList;

  let message = '';
  if (tempList.length > 0) {
    message = i18n.$t('OCAP').editStageSettingExplain;
  } else {
    message = i18n.$t('DriverTourHelp').createDataFirst;
  }

  const driverObj = driver({
    showProgress: true,
    steps: [
      {
        element: '.btnEdit',
        popover: {
          title: i18n.$t('OCAP').editStageSetting,
          description: message,
          onPopoverRender: () => {
            if (tempList.length === 0) {
              const nextBtn = document.querySelector('.driver-popover-next-btn');
              if (nextBtn) {
                console.log('nextBtn', nextBtn);
                nextBtn.setAttribute('disabled', 'true');
                nextBtn.setAttribute('style', 'color:#D0D0D0;cursor: default');
                nextBtn.classList.add('disabled'); // 可加上樣式
              }
            }
          },
        },
      },

      {
        element: '.btnDelete',
        popover: {
          title: i18n.$t('OCAP').deleteStageSetting,
          description: i18n.$t('OCAP').deleteStageSettingExplain,
        },
      },

      {
        popover: {
          title: i18n.$t('OCAP').editDeleteStageSetting,
          description: i18n.$t('OCAP').stageSettingExplain,
        },
      },
    ],
    prevBtnText: i18n.$t('DriverTourHelp').previous,
    nextBtnText: i18n.$t('DriverTourHelp').next,
    doneBtnText: i18n.$t('DriverTourHelp').done,
  });

  driverObj.drive();
}

/**
 * 呼叫 OCAP關卡設定
 * @param {*} i18n
 * @param {*} store
 */
export function callHelpFlowSetting(i18n, store) {
  const driverObj = driver({
    showProgress: true,
    steps: [
      {
        element: '.filterBtn',
        popover: {
          title: i18n.$t('OCAP').flowSettingFilter,
          description: i18n.$t('OCAP').flowSettingFilterExplain,
        },
      },

      {
        element: '.button-add',
        popover: {
          title: i18n.$t('OCAP').flowSettingFilterCreate,
          description: i18n.$t('OCAP').flowSettingFilterCreateExplain,
          onNextClick: () => {
            if (store.state.ocap.flowSettingFormVisible) {
              driverObj.moveNext();
            } else {
              driverObj.destroy();

              ElMessage({
                showClose: true,
                message: i18n.$t('DriverTourHelp').ClickAddButtonFirst,
                type: 'error',
                duration: 3000,
              });

              setTimeout(() => {
                driverObj.drive();
                driverObj.moveTo(1);
              }, 3000);
            }
          },
        },
      },

      {
        element: '.nameInput',
        popover: {
          title: i18n.$t('OCAP').flowSettingFilterCreate,
          description: i18n.$t('OCAP').flowSettingName,
        },
      },

      {
        element: '#addFlow',
        popover: {
          title: i18n.$t('OCAP').flowSettingAddStage,
          description: i18n.$t('OCAP').flowSettingAddStageExplain,
        },
      },

      {
        element: '.insertFlow',
        popover: {
          title: i18n.$t('OCAP').flowSettingInsertStage,
          description: i18n.$t('OCAP').flowSettingInsertStageExplain,
        },
      },

      {
        element: '.el-table_2_column_4.is-leaf.el-table__cell',
        popover: {
          title: i18n.$t('OCAP').flowSettingAddStage,
          description: i18n.$t('OCAP').flowSettingSequenceLimit,
        },
      },

      {
        element: '.condition',
        popover: {
          title: i18n.$t('OCAP').flowSettingIsConflict,
          description: `
          <p>${i18n.$t('OCAP').flowSettingCheckConflict}</p>
          <p>${i18n.$t('OCAP').flowSettingNoCheckConflict}</p>`,
        },
      },

      {
        element: '#stagePositive',
        popover: {
          title: i18n.$t('OCAP').flowSettingStage,
          description: i18n.$t('OCAP').flowSettingStageExplain,
        },
      },

      {
        element: '#stageNegative',
        popover: {
          title: i18n.$t('OCAP').flowSettingStage,
          description: i18n.$t('OCAP').flowSettingStageExplain,
        },
      },

      {
        popover: {
          title: i18n.$t('OCAP').flowSettingStage,
          description: `
          <p>${i18n.$t('OCAP').flowSettingStageSequence}</p>
          <p>${i18n.$t('OCAP').flowSettingFinalStage}</p>`,
        },
      },

      {
        element: '#deleteBtn',
        popover: {
          title: i18n.$t('OCAP').flowSettingDelete,
          description: `
          <p>${i18n.$t('OCAP').flowSettingDeleteExplain}</p>
          <p>${i18n.$t('OCAP').flowSettingNoModifyDelete}</p>`,
        },
      },

      {
        element: '.btn-confirm',
        popover: {
          title: i18n.$t('OCAP').flowSettingConfirm,
          description: i18n.$t('OCAP').flowSettingConfirmExplain,
        },
      },
    ],
    prevBtnText: i18n.$t('DriverTourHelp').previous,
    nextBtnText: i18n.$t('DriverTourHelp').next,
    doneBtnText: i18n.$t('DriverTourHelp').done,
  });

  driverObj.drive();
}

/**
 * 呼叫OCAP設定範例
 * @param {*} i18n
 * @param {*} store
 */
export function callHelpOCAPSettingExample(i18n, store) {
  let flowChart = null;
  let imgSource1 = null;
  let imgSource2 = null;
  let imgSource3 = null;
  let imgSource4 = null;
  let imgSource5 = null;
  let flowImg = null;

  switch (store.state.lang) {
    case 'zhtw':
      flowChart = flowChartTw;
      imgSource1 = stage1Tw;
      imgSource2 = stage2Tw;
      imgSource3 = stage3Tw;
      imgSource4 = stage4Tw;
      imgSource5 = stage5Tw;
      flowImg = setFlowTw;
      break;

    case 'en':
      flowChart = flowChartEn;
      imgSource1 = stage1En;
      imgSource2 = stage2En;
      imgSource3 = stage3En;
      imgSource4 = stage4En;
      imgSource5 = stage5En;
      flowImg = setFlowEn;
      break;

    case 'cn':
      flowChart = flowChartCn;
      imgSource1 = stage1Cn;
      imgSource2 = stage2Cn;
      imgSource3 = stage3Cn;
      imgSource4 = stage4Cn;
      imgSource5 = stage5Cn;
      flowImg = setFlowCn;
      break;

    default:
      flowChart = flowChartTw;
      imgSource1 = stage1Tw;
      imgSource2 = stage2Tw;
      imgSource3 = stage3Tw;
      imgSource4 = stage4Tw;
      imgSource5 = stage5Tw;
      flowImg = setFlowTw;
      break;
  }

  const driverObj = driver({
    showProgress: true,
    steps: [
      {
        popover: {
          title: i18n.$t('OCAP').flowSettingStage,
          description: `
          <p>${i18n.$t('OCAP').settingExampleStageExplain}</p>
          <img src='${flowChart}' width="350"/>
          `,
          popoverClass: 'flowChart',
        },
      },

      {
        popover: {
          title: `${i18n.$t('OCAP').stage} 1`,
          description: `
          <img src='${imgSource1}' width="900"/>
          <p>${i18n.$t('OCAP').settingExampleIsSign}</p>
          <p>${i18n.$t('OCAP').settingExampleIsAllSign}</p>
          <p>${i18n.$t('OCAP').settingExampleEMailNotice}</p>
          `,
          popoverClass: 'imgExplain',
        },
      },

      {
        popover: {
          title: `${i18n.$t('OCAP').stage} 2`,
          description: `<img src='${imgSource2}' width="1024"/>`,
          popoverClass: 'imgExplain',
        },
      },

      {
        popover: {
          title: `${i18n.$t('OCAP').stage} 3`,
          description: `<img src='${imgSource3}' width="1024"/>`,
          popoverClass: 'imgExplain',
        },
      },

      {
        popover: {
          title: `${i18n.$t('OCAP').stage} 4`,
          description: `<img src='${imgSource4}' width="1024"/>`,
          popoverClass: 'imgExplain',
        },
      },

      {
        popover: {
          title: `${i18n.$t('OCAP').stage} 5`,
          description: `<img src='${imgSource5}' width="1024"/>`,
          popoverClass: 'imgExplain',
        },
      },

      {
        popover: {
          title: `${i18n.$t('OCAP').settingExampleFlowExplain}`,
          description: `
          <p>${i18n.$t('OCAP').selectStageExplain}</p>
          <img src='${flowImg}' width="1024"/>`,
          popoverClass: 'imgExplain',
        },
      },

      {
        popover: {
          title: `${i18n.$t('OCAP').settingExampleFlowExplain}`,
          description: `
          <p>${i18n.$t('OCAP').setFlowExplain}</p>
          <p>${i18n.$t('OCAP').setFlowExplainMore}</p>`,
          popoverClass: 'imgFinal',
        },
      },
    ],
    prevBtnText: i18n.$t('DriverTourHelp').previous,
    nextBtnText: i18n.$t('DriverTourHelp').next,
    doneBtnText: i18n.$t('DriverTourHelp').done,
  });
  driverObj.drive();
}

/**
 * 呼叫 簽核查詢
 * @param {*} i18n
 */
export function callHelpSignatureQuery(i18n) {
  const driverObj = driver({
    showProgress: true,
    steps: [
      {
        element: '#empId',
        popover: {
          title: i18n.$t('OCAP').SignatureQuery.empIdDropDownList,
          description: i18n.$t('OCAP').SignatureQuery.empIdDropDownListExplain,
        },
      },
      {
        element: '#signType',
        popover: {
          title: i18n.$t('OCAP').SignatureQuery.signTypeDropDownList,
          description: i18n.$t('OCAP').SignatureQuery.signTypeDropDownListExplain,
        },
      },
      {
        element: '.searchbutton',
        popover: {
          title: i18n.$t('OCAP').SignatureQuery.filter,
          description: i18n.$t('OCAP').SignatureQuery.filterExplain,
        },
      },
      {
        popover: {
          title: i18n.$t('OCAP').SignatureQuery.filter,
          description: i18n.$t('OCAP').SignatureQuery.searchExplain,
        },
      },
      {
        element: '#handleBtn',
        popover: {
          title: i18n.$t('OCAP').SignatureQuery.handle,
          description: i18n.$t('OCAP').SignatureQuery.handleExplain,
        },
      },
    ],
    prevBtnText: i18n.$t('DriverTourHelp').previous,
    nextBtnText: i18n.$t('DriverTourHelp').next,
    doneBtnText: i18n.$t('DriverTourHelp').done,
  });
  driverObj.drive();
}

/**
 * 呼叫 簽核查詢處理
 * @param {*} i18n
 * @param {*} store
 */
export function callHelpSignatureQueryHandle(i18n, store) {
  const tempList = store.state.ocap.ocapSignRecordList;

  let explainText = '';
  if (tempList.length > 0) {
    explainText = i18n.$t('OCAP').SignatureQuery.handleExplain;
  } else {
    explainText = i18n.$t('OCAP').SignatureQuery.referenceControlItemSettings;
  }

  const driverObj = driver({
    showProgress: true,
    steps: [
      {
        element: '#handleBtn',
        popover: {
          title: i18n.$t('OCAP').SignatureQuery.handle,
          description: explainText,
          onPopoverRender: () => {
            if (tempList.length === 0) {
              const nextBtn = document.querySelector('.driver-popover-next-btn');
              if (nextBtn) {
                console.log('nextBtn', nextBtn);
                nextBtn.setAttribute('disabled', 'true');
                nextBtn.setAttribute('style', 'color:#D0D0D0;cursor: default');
                nextBtn.classList.add('disabled'); // 可加上樣式
              }
            }
          },
          onNextClick: () => {
            if (store.state.ocap.signatureQueryHandleVisible) {
              driverObj.moveNext();
            } else {
              driverObj.destroy();

              ElMessage({
                showClose: true,
                message: i18n.$t('DriverTourHelp').ClickHandleButtonFirst,
                type: 'error',
                duration: 3000,
              });

              setTimeout(() => {
                driverObj.drive();
              }, 3000);
            }
          },
        },
      },
      {
        element: '#abnormalReason',
        popover: {
          title: i18n.$t('OCAP').SignatureQuery.abnormalReason,
          description: `
          <p>${i18n.$t('DriverTourHelp').ColumnIsRequire}</p>
          <p>${i18n.$t('OCAP').SignatureQuery.abnormalReasonExplain}</p>`,
        },
      },
      {
        element: '#checkJudge',
        popover: {
          title: i18n.$t('OCAP').SignatureQuery.checkJudge,
          description: `
          <p>${i18n.$t('DriverTourHelp').ColumnIsRequire}</p>
          <p>${i18n.$t('OCAP').SignatureQuery.checkJudgeExplain}</p>`,
        },
      },
      {
        popover: {
          title: i18n.$t('OCAP').SignatureQuery.handle,
          description: i18n.$t('OCAP').SignatureQuery.signExplainMore,
        },
      },
      {
        element: '#selectStage',
        popover: {
          title: i18n.$t('OCAP').SignatureQuery.selectStage,
          description: i18n.$t('OCAP').SignatureQuery.selectStageExplain,
        },
      },
      {
        element: '#signFlow',
        popover: {
          title: i18n.$t('OCAP').SignatureQuery.signFlow,
          description: i18n.$t('OCAP').SignatureQuery.signFlowExplain,
        },
      },
      {
        element: '#signHistory',
        popover: {
          title: i18n.$t('OCAP').SignatureQuery.signHistory,
          description: i18n.$t('OCAP').SignatureQuery.signHistoryExplain,
        },
      },
      {
        element: '.btn-confirm',
        popover: {
          title: i18n.$t('OCAP').SignatureQuery.confirm,
          description: i18n.$t('OCAP').SignatureQuery.confirmExplain,
        },
      },
      {
        element: '.form-wrap',
        popover: {
          title: i18n.$t('OCAP').SignatureQuery.handle,
          description: i18n.$t('OCAP').SignatureQuery.signExplain,
        },
      },
      {
        popover: {
          title: i18n.$t('OCAP').SignatureQuery.judgeRule,
          description: i18n.$t('OCAP').SignatureQuery.judgeRuleExPlain,
        },
      },
    ],
    prevBtnText: i18n.$t('DriverTourHelp').previous,
    nextBtnText: i18n.$t('DriverTourHelp').next,
    doneBtnText: i18n.$t('DriverTourHelp').done,
  });
  driverObj.drive();
}
